import React from 'react';
import { useTranslation } from 'react-i18next';

import s from './ReadyToGoCore.scss';

export interface Props {}

const ReadyToGoCore: React.FC<Props> = () => {
  const { t } = useTranslation();
  return (
    <div className={s['root']}>{t('packagePicker.readyToGoCore.header')}</div>
  );
};
ReadyToGoCore.displayName = 'ReadyToGoCore';

export default ReadyToGoCore;
